import type { Fulfilment } from '@/types/api'

import type { CartLine, CartShop } from './store'

/** Header / bottom-nav badge: total quantity (BR-7). */
export const cartCount = (lines: CartLine[]) => lines.reduce((n, l) => n + l.quantity, 0)

export interface ShopGroup {
  shop: CartShop
  lines: CartLine[]
  itemsTotal: number
  onRequestCount: number
}

/** Cart grouped by shop in first-added order; totals skip price-on-request lines (BR-2). */
export function groupByShop(lines: CartLine[]): ShopGroup[] {
  const groups = new Map<number, ShopGroup>()
  for (const line of lines) {
    const g = groups.get(line.shop.id) ?? {
      shop: line.shop,
      lines: [],
      itemsTotal: 0,
      onRequestCount: 0,
    }
    g.lines.push(line)
    if (line.price == null) g.onRequestCount += 1
    else g.itemsTotal += line.price * line.quantity
    groups.set(line.shop.id, g)
  }
  return [...groups.values()]
}

export interface FulfilmentOptions {
  hasHomeDelivery: boolean
  hasSelfPickup: boolean
}

/** Pickup preselected when offered, else Delivery (BR-6). */
export function defaultFulfilment(shop: FulfilmentOptions): Fulfilment {
  return shop.hasSelfPickup ? 'pickup' : 'delivery'
}

/** The saved choice if the shop still offers it, else the default (BR-6). */
export function chosenFulfilment(
  shop: FulfilmentOptions,
  saved: Fulfilment | undefined,
): Fulfilment {
  if (saved === 'delivery' && shop.hasHomeDelivery) return saved
  if (saved === 'pickup' && shop.hasSelfPickup) return saved
  return defaultFulfilment(shop)
}
